<template>
  <b-row>
    <div class="col-12 col-sm-9">
      <b-card class="mb-3" :header="heading" no-body>
        <div class="card-body">
          <b-row>
            <b-col cols="12">
              <b-form-group label="Type:" v-if="!type">
                <b-v-select
                  id="form-input-type"
                  name="form-input-type"
                  v-model="itemForm.type"
                  v-validate="{ required: true }"
                  :state="validateState('form-input-type')"
                  :searchable="true"
                  :options="reportTypesListFiltered"
                />
                <b-form-invalid-feedback id="form-input-type-feedback">
                  {{ veeErrors.first('form-input-type') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <section v-if="itemForm.type == 'OrderedStorefrontItemsReport'">
            <OrderedStorefrontItemsReport-form :reportFilters="itemForm.orderedItemsReportFilters"></OrderedStorefrontItemsReport-form>
          </section>
          <section v-if="itemForm.type == 'OrderedWarehouseItemsReport'">
            <OrderedWarehouseItemsReport-form :reportFilters="itemForm.orderedItemsReportFilters">
            </OrderedWarehouseItemsReport-form>
          </section>
          <section v-else-if="itemForm.type == 'ReportFinanceMargin' && has('pm.orders.view.financeMargin')">
            <ReportFinanceMarginReport-form :reportFilters="itemForm.financeMarginReportFilters"></ReportFinanceMarginReport-form>
          </section>
          <section v-else-if="itemForm.type == 'ReportFinanceMarginSummary' && has('pm.orders.view.financeMargin')">
            <ReportFinanceMarginReportSummary-form :reportFilters="itemForm.financeMarginReportFilters"></ReportFinanceMarginReportSummary-form>
          </section>
          <section v-else-if="itemForm.type == 'ReportItemsOnBackorder'">
            <ReportItemsOnBackorder-form :reportFilters="itemForm.requestFilters"></ReportItemsOnBackorder-form>
          </section>
          <section v-else-if="itemForm.type == 'FactoringFinanceInvoiceReport'">
            <FactoringFinanceInvoiceReport-form :reportFilters="itemForm.factoringFinanceInvoiceFilters"></FactoringFinanceInvoiceReport-form>
          </section>
          <section v-else-if="itemForm.type == 'InventoryStatusItemsReport'">
            <InventoryStatusItemsReport-form :reportFilters="itemForm.inventoryTotalReportFilters"></InventoryStatusItemsReport-form>
          </section>
          <section v-else-if="itemForm.type == 'StorefrontShippedCount'">
            <StorefrontShippedCount-form :reportFilters="itemForm.shipmentCountReportFilters"></StorefrontShippedCount-form>
          </section>
          <section v-else-if="itemForm.type == 'StorefrontReshipReportByMonth'">
            <StorefrontReshipReportByMonth-form :reportFilters="itemForm.storefrontReshipReportByMonthFilters"></StorefrontReshipReportByMonth-form>
          </section>
          <section v-else-if="itemForm.type == 'WarehouseItemsInOutReport'">
            <WarehouseItemsInOutReport-form :reportFilters="itemForm.warehouseItemsInOutReportFilters"></WarehouseItemsInOutReport-form>
          </section>

          <section v-else-if="itemForm.type == 'OrderFulfillmentsReport'">
            <OrderFulfillmentsReport-form :reportFilters="itemForm.orderFulfillmentReportFilters"></OrderFulfillmentsReport-form>
          </section>
          <section v-else-if="itemForm.type == 'HistoricalInventoryReport'">
            <HistoricalInventoryReport-form :reportFilters="itemForm.inventoryHistoricalReportFilters"></HistoricalInventoryReport-form>
          </section>
        </div>
      </b-card>
    </div>
    <aside class="col-12 col-sm-3">
      <b-card header="Actions">
        <b-button
          :disabled="savingItem"
          variant="primary"
          block
          type="submit"
          @click="SaveForm"
        >
          <span v-if="savingItem">Processing...</span>
          <span v-else>Generate Report</span>
        </b-button>
        <router-link
          :disabled="savingItem"
          class="mt-2 btn btn-block btn-outline-danger"
          :to="{ name: 'Reports.GeneratedReports.Index' }"
        >
          <span>Cancel</span>
        </router-link>
      </b-card>
    </aside>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import { mapStoreGetSet } from '@/helpers/utils/storeHelpers.js';
import OrderedStorefrontItemsReport from './formPartials/OrderedStorefrontItemsReport'
import OrderedWarehouseItemsReport from './formPartials/OrderedWarehouseItemsReport'
import OrderFulfillmentsReport from './formPartials/OrderFulfillmentsReport'
import StorefrontShippedCount from './formPartials/StorefrontShippedCount'
import StorefrontReshipReportByMonth from './formPartials/StorefrontReshipReportByMonth'
import WarehouseItemsInOutReport from './formPartials/WarehouseItemsInOutReport'
import ReportFinanceMarginReport from './formPartials/ReportFinanceMarginReport'
import ReportFinanceMarginReportSummary from './formPartials/ReportFinanceMarginReportSummary'
import ReportItemsOnBackorder from './formPartials/ReportItemsOnBackorder'
import InventoryStatusItemsReport from './formPartials/InventoryStatusItemsReport'
import FactoringFinanceInvoiceReport from './formPartials/FactoringFinanceInvoiceReport'
import HistoricalInventoryReport from './formPartials/HistoricalInventoryReport'
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
const mixinCrud = crudMixinGen('generatedReports');
export default {
  mixins: [mixinCrud, myCommonDataMixin],
  components: {
    'FactoringFinanceInvoiceReport-form': FactoringFinanceInvoiceReport,
    'OrderedWarehouseItemsReport-form': OrderedWarehouseItemsReport,
    'OrderedStorefrontItemsReport-form': OrderedStorefrontItemsReport,
    'OrderFulfillmentsReport-form': OrderFulfillmentsReport,
    'WarehouseItemsInOutReport-form': WarehouseItemsInOutReport,
    'ReportFinanceMarginReport-form': ReportFinanceMarginReport,
    'ReportFinanceMarginReportSummary-form': ReportFinanceMarginReportSummary,
    'ReportItemsOnBackorder-form': ReportItemsOnBackorder,
    'StorefrontShippedCount-form': StorefrontShippedCount,
    'StorefrontReshipReportByMonth-form': StorefrontReshipReportByMonth,
    'InventoryStatusItemsReport-form': InventoryStatusItemsReport,
    'HistoricalInventoryReport-form': HistoricalInventoryReport,
  },
  props: {
    type: {
      type: String,
      required: false,
      default: ''
    }
  },

  data: () => ({
    heading: 'Generate Report',
  }),

  computed: {
    ...mapState('generatedReports', ['reportTypesList']),
    reportTypesListFiltered: {
      get() {
        var reportTypes = this.reportTypesList;
        if(this.has('pm.orders.view.financeMargin')) {
          reportTypes.push({ value: 'ReportFinanceMargin', text: 'Client Billing: By Order Margin' });
          reportTypes.push({ value: 'ReportFinanceMarginSummary', text: 'Client Billing: Margin Summary' });
        }
        if(this.is('brand-user')) {
          reportTypes = [

          ];
        }
        return reportTypes;
      },
      set() {

      }
    }
  },

  mounted() {
    this.ResetForm();
    if(this.type) {
      this.itemForm.type = this.type;
    }
  },

  methods: {
    SaveForm() {
      this.savingItem = true;
      this.SaveItem()
        .then(resp => {
          this.$swal({ title: 'Report is being generated, could take a minute...', icon: 'success' });
          this.$router.push({
            name: 'Reports.GeneratedReports.Index',
            params: { type: this.itemForm.type}
          });
          this.ResetForm();
        })
        .catch(err => {
          this.savingItem = false;
          if (err.response && err.response.data && err.response.data.errorMessage) {
            this.$swal({ title: err.response.data.errorMessage, icon: 'error' });
          } else {
            this.$swal({ title: 'Report Was NOT created!', icon: 'error' });
          }
        });
    }
  }
};
</script>
